<template>
	<div class="product-details">
		<div class="product-details__inner _cnt">
			<div class="product-details__top">
				<BaseButton class="product-details__back" @click="goBack()">
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M23 12H1M1 12L7 6M1 12L7 18"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
				</BaseButton>
				<div class="product-details__title _h1">{{ $t('Product') }}</div>
			</div>
			<div class="product-details__body" v-if="product">
				<div class="product-details__image-container">
					<div class="product-details__image-bg _ibg-contain">
						<img src="@/assets/img/bg/product-page-card-bg.png" />
					</div>
					<div class="product-details__image _ibg-contain">
						<img
							:src="product?.image_url || imgDomain + product?.img_url"
							:alt="product?.name || product?.title"
						/>
					</div>
					<div
						v-if="product?.id === chosenItem"
						class="product-details__added-inscription"
					>
						{{ $t(`Added`) }}
					</div>
				</div>
				<div class="product-details__info">
					<div class="product-details__name _h3">
						{{ product?.name || product?.title }}
					</div>
					<div class="product-details__about">
						<div class="product-details__about-item">
							<div class="product-details__about-name">
								{{ $t('Type') }}:
							</div>
							<div class="product-details__about-value">
								{{ product?.type }}
							</div>
						</div>
						<div class="product-details__about-item">
							<div class="product-details__about-name">
								{{ $t('Quality') }}:
							</div>
							<div class="product-details__about-value">
								{{ product?.quality }}
							</div>
						</div>
					</div>
					<div class="product-details__bottom">
						<div class="product-details__price">
							<div class="product-details__price-value">
								{{ Number(product.internal_price ?? product.price).toFixed(2) }}
							</div>
							<div class="product-details__price-icon _svg-icon">
								<svg
									width="19"
									height="19"
									viewBox="0 0 19 19"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M9.16667 18.3333C14.2293 18.3333 18.3333 14.2293 18.3333 9.16667C18.3333 4.10406 14.2293 0 9.16667 0C4.10406 0 0 4.10406 0 9.16667C0 14.2293 4.10406 18.3333 9.16667 18.3333Z"
										fill="#FFE180"
									/>
									<path
										d="M9.16634 16.5C13.2164 16.5 16.4997 13.2168 16.4997 9.16667C16.4997 5.11658 13.2164 1.83333 9.16634 1.83333C5.11625 1.83333 1.83301 5.11658 1.83301 9.16667C1.83301 13.2168 5.11625 16.5 9.16634 16.5Z"
										fill="#FFB030"
									/>
									<path
										d="M9.16699 16.0417C12.964 16.0417 16.042 12.9636 16.042 9.16667C16.042 5.36971 12.964 2.29167 9.16699 2.29167C5.37003 2.29167 2.29199 5.36971 2.29199 9.16667C2.29199 12.9636 5.37003 16.0417 9.16699 16.0417Z"
										fill="#FFC926"
									/>
									<path
										d="M4.06861 9.16337C4.06861 9.31863 3.94152 9.44567 3.78626 9.44567C3.63099 9.44567 3.50391 9.31863 3.50391 9.16337C3.50391 9.00104 3.63099 8.88102 3.78626 8.88102C3.94152 8.88102 4.06861 9.00104 4.06861 9.16337Z"
										fill="white"
									/>
									<path
										d="M4.87364 6.68588C4.95132 6.55177 5.12071 6.50942 5.25482 6.58705C5.38893 6.66469 5.43835 6.83412 5.36067 6.96823C5.28304 7.10234 5.11365 7.15171 4.97247 7.07408C4.83836 6.99646 4.79602 6.82 4.87364 6.68588Z"
										fill="white"
									/>
									<path
										d="M5.37408 11.3726C5.45171 11.5067 5.40936 11.6761 5.27525 11.7608C5.14115 11.8385 4.96469 11.789 4.88705 11.6549C4.80942 11.5208 4.85177 11.3514 4.99295 11.2667C5.12706 11.1891 5.29645 11.2385 5.37408 11.3726Z"
										fill="white"
									/>
									<path
										d="M6.02377 9.16336C6.02377 9.3963 5.84024 9.58685 5.60028 9.58685C5.36735 9.58685 5.17676 9.3963 5.17676 9.16336C5.17676 8.92336 5.36735 8.73984 5.60028 8.73984C5.84024 8.73984 6.02377 8.92336 6.02377 9.16336Z"
										fill="white"
									/>
									<path
										d="M6.7368 13.963C6.66624 14.0971 6.48978 14.1395 6.35567 14.0689C6.22156 13.9913 6.17215 13.8148 6.24978 13.6807C6.32741 13.5466 6.49685 13.4972 6.63798 13.5748C6.77209 13.6525 6.81443 13.8219 6.7368 13.963Z"
										fill="white"
									/>
									<path
										d="M6.24294 4.63896C6.16531 4.50485 6.21473 4.32839 6.34884 4.25076C6.48294 4.17313 6.6594 4.22253 6.73704 4.35664C6.81467 4.49075 6.76525 4.66721 6.63119 4.74484C6.49707 4.82247 6.32061 4.77307 6.24294 4.63896Z"
										fill="white"
									/>
									<path
										d="M6.89883 7.37052C7.10355 7.48348 7.17411 7.74463 7.05414 7.94931C6.94118 8.15403 6.68003 8.21753 6.47535 8.10462C6.27067 7.98463 6.20713 7.73051 6.32008 7.52583C6.44006 7.32115 6.69415 7.25054 6.89883 7.37052Z"
										fill="white"
									/>
									<path
										d="M6.913 10.9632C6.70832 11.0832 6.45423 11.0126 6.33421 10.808C6.21422 10.6103 6.28479 10.3492 6.48245 10.2292C6.68712 10.1162 6.94828 10.1798 7.0683 10.3844C7.18122 10.5892 7.11767 10.8433 6.913 10.9632Z"
										fill="white"
									/>
									<path
										d="M7.46365 9.86242C7.85347 9.86242 8.16948 9.5464 8.16948 9.15658C8.16948 8.76676 7.85347 8.45075 7.46365 8.45075C7.07383 8.45075 6.75781 8.76676 6.75781 9.15658C6.75781 9.5464 7.07383 9.86242 7.46365 9.86242Z"
										fill="white"
									/>
									<path
										d="M7.76038 12.4525C7.64742 12.6573 7.38627 12.7278 7.18865 12.6149C6.98398 12.4949 6.91337 12.2337 7.02633 12.0361C7.14631 11.8314 7.4004 11.7608 7.60508 11.8737C7.80979 11.9938 7.88035 12.2479 7.76038 12.4525Z"
										fill="white"
									/>
									<path
										d="M7.02635 6.28356C6.90633 6.07888 6.97694 5.82479 7.18161 5.70476C7.38629 5.59185 7.64042 5.66241 7.7604 5.86007C7.87332 6.06474 7.80275 6.3259 7.59808 6.43886C7.40042 6.55884 7.13926 6.48823 7.02635 6.28356Z"
										fill="white"
									/>
									<path
										d="M8.31033 11.33C8.70015 11.33 9.01616 11.014 9.01616 10.6242C9.01616 10.2343 8.70015 9.91833 8.31033 9.91833C7.9205 9.91833 7.60449 10.2343 7.60449 10.6242C7.60449 11.014 7.9205 11.33 8.31033 11.33Z"
										fill="white"
									/>
									<path
										d="M8.31033 8.39392C8.70015 8.39392 9.01616 8.0779 9.01616 7.68808C9.01616 7.29826 8.70015 6.98225 8.31033 6.98225C7.9205 6.98225 7.60449 7.29826 7.60449 7.68808C7.60449 8.0779 7.9205 8.39392 8.31033 8.39392Z"
										fill="white"
									/>
									<path
										d="M9.58138 12.0008C9.58138 12.2337 9.39079 12.4243 9.15786 12.4243C8.92496 12.4243 8.73438 12.2337 8.73438 12.0008C8.73438 11.7679 8.92497 11.5773 9.15786 11.5773C9.39079 11.5773 9.58138 11.7679 9.58138 12.0008Z"
										fill="white"
									/>
									<path
										d="M8.73438 6.33297C8.73438 6.10003 8.92497 5.90948 9.15786 5.90948C9.39079 5.90948 9.58138 6.10003 9.58138 6.33297C9.58138 6.5659 9.39079 6.75646 9.15786 6.75646C8.92496 6.75646 8.73438 6.56591 8.73438 6.33297Z"
										fill="white"
									/>
									<path
										d="M9.43966 13.8148C9.43966 13.9701 9.31262 14.0971 9.15731 14.0971C9.00204 14.0971 8.875 13.9701 8.875 13.8148C8.875 13.6595 9.00204 13.5325 9.15731 13.5325C9.31261 13.5325 9.43966 13.6595 9.43966 13.8148Z"
										fill="white"
									/>
									<path
										d="M8.875 4.51897C8.875 4.36371 9.00204 4.23667 9.15731 4.23667C9.31262 4.23667 9.43966 4.36371 9.43966 4.51897C9.43966 4.67428 9.31262 4.80133 9.15731 4.80133C9.00204 4.80133 8.875 4.67428 8.875 4.51897Z"
										fill="white"
									/>
									<path
										d="M9.99685 11.33C10.3867 11.33 10.7027 11.014 10.7027 10.6242C10.7027 10.2343 10.3867 9.91833 9.99685 9.91833C9.60703 9.91833 9.29102 10.2343 9.29102 10.6242C9.29102 11.014 9.60703 11.33 9.99685 11.33Z"
										fill="white"
									/>
									<path
										d="M9.99685 8.39392C10.3867 8.39392 10.7027 8.0779 10.7027 7.68808C10.7027 7.29826 10.3867 6.98225 9.99685 6.98225C9.60703 6.98225 9.29102 7.29826 9.29102 7.68808C9.29102 8.0779 9.60703 8.39392 9.99685 8.39392Z"
										fill="white"
									/>
									<path
										d="M10.8513 9.86242C11.2412 9.86242 11.5572 9.5464 11.5572 9.15658C11.5572 8.76676 11.2412 8.45075 10.8513 8.45075C10.4615 8.45075 10.1455 8.76676 10.1455 9.15658C10.1455 9.5464 10.4615 9.86242 10.8513 9.86242Z"
										fill="white"
									/>
									<path
										d="M10.5478 5.86008C10.6678 5.65536 10.9219 5.58479 11.1266 5.70478C11.3313 5.81774 11.4018 6.07889 11.2819 6.28356C11.1689 6.48121 10.9078 6.55178 10.7101 6.43887C10.5055 6.31884 10.4349 6.06475 10.5478 5.86008Z"
										fill="white"
									/>
									<path
										d="M11.2889 12.029C11.4089 12.2337 11.3384 12.4949 11.1336 12.6078C10.929 12.7278 10.6678 12.6573 10.5549 12.4525C10.4419 12.2479 10.5125 11.9867 10.7102 11.8737C10.9148 11.7608 11.176 11.8314 11.2889 12.029Z"
										fill="white"
									/>
									<path
										d="M11.4023 7.34938C11.5999 7.23646 11.8611 7.29996 11.9811 7.50464C12.094 7.70229 12.0305 7.96345 11.8258 8.08343C11.6282 8.20345 11.367 8.13285 11.247 7.92817C11.1271 7.73051 11.1976 7.46935 11.4023 7.34938Z"
										fill="white"
									/>
									<path
										d="M11.416 10.9421C11.2113 10.8291 11.1407 10.568 11.2607 10.3633C11.3736 10.1656 11.6348 10.0951 11.8395 10.208C12.0371 10.328 12.1077 10.5892 11.9948 10.7868C11.8748 10.9914 11.6136 11.0621 11.416 10.9421Z"
										fill="white"
									/>
									<path
										d="M12.0659 13.6807C12.1436 13.8148 12.1012 13.9842 11.9671 14.0619C11.8259 14.1395 11.6566 14.0901 11.5789 13.956C11.5012 13.8219 11.5507 13.6525 11.6848 13.5748C11.8189 13.4972 11.9883 13.5395 12.0659 13.6807Z"
										fill="white"
									/>
									<path
										d="M11.5721 4.35664C11.6497 4.21547 11.8262 4.17312 11.9603 4.25075C12.0944 4.32838 12.1438 4.49782 12.0661 4.63193C11.9885 4.77306 11.812 4.81541 11.6779 4.73777C11.5438 4.66015 11.4944 4.49076 11.5721 4.35664Z"
										fill="white"
									/>
									<path
										d="M12.7077 9.57979C12.4748 9.57979 12.2842 9.38924 12.2842 9.15631C12.2842 8.92337 12.4748 8.73283 12.7077 8.73283C12.9406 8.73283 13.1312 8.92337 13.1312 9.15631C13.1312 9.38924 12.9406 9.57979 12.7077 9.57979Z"
										fill="white"
									/>
									<path
										d="M12.9334 6.93997C12.8557 6.80586 12.9051 6.63647 13.0393 6.55884C13.1734 6.48121 13.3428 6.52356 13.4275 6.65767C13.5051 6.79178 13.4557 6.96823 13.3216 7.04587C13.1875 7.1235 13.0181 7.08115 12.9334 6.93997Z"
										fill="white"
									/>
									<path
										d="M13.4417 11.6267C13.3641 11.7608 13.1947 11.8102 13.0535 11.7326C12.9194 11.6549 12.8771 11.4785 12.9547 11.3444C13.0323 11.2103 13.2018 11.1609 13.3359 11.2385C13.4699 11.3162 13.5194 11.4926 13.4417 11.6267Z"
										fill="white"
									/>
									<path
										d="M14.8117 9.1563C14.8117 9.31156 14.6847 9.43865 14.5294 9.43865C14.367 9.43865 14.2471 9.31156 14.2471 9.1563C14.2471 9.00103 14.3671 8.87395 14.5294 8.87395C14.6847 8.87396 14.8117 9.00104 14.8117 9.1563Z"
										fill="white"
									/>
								</svg>
							</div>
						</div>
						<div class="product-details__actions">
							<BaseButton
								class="product-details__button _btn-primary"
								@click="addToCartAndBuy(product)"
								>{{ $t('Buy') }}</BaseButton
							>
							<BaseButton
								class="product-details__button _btn-bordered"
								@click="addToCart(product)"
								>{{ $t('Add to Cart') }}</BaseButton
							>
						</div>
					</div>
				</div>
			</div>
			<div
				v-else-if="!product && !productLoading"
				class="product-details__no-product _l"
			>
				{{ $t('Product not found') }}
			</div>
			<ProductCarousel
				v-if="product?.similar && product.similar.length > 0"
				:title="$t('More in this category')"
				:chosenItem="chosenItem"
				showArrows="false"
				@goToProduct="goToProduct"
				@addToCart="addToCart"
				:background="'none'"
				:initialProducts="product?.similar"
			/>
		</div>
	</div>
</template>

<script>
import ProductCarousel from '@/components/ProductCarousel.vue';
import BaseButton, { ButtonThemes } from '@/components/base/BaseButton.vue';
import { Chart, registerables } from 'chart.js';
import { mapGetters } from 'vuex';

Chart.register(...registerables);

export default {
	name: 'ProductPage',
	components: {
		ProductCarousel,
		BaseButton,
	},
	props: {
		isAuth: {
			type: Boolean,
			required: true,
		},
		id: {
			type: String,
		},
		chosenItem: {
			type: String,
		},
	},
	data() {
		return {
			product: null,
			chart: null,
			// chartData: [],
			imgDomain: '',
			productLoading: true,
			ButtonThemes,
		};
	},
	computed: {
		...mapGetters('app', ['currencyCode', 'currencySymbol']),
		...mapGetters('cart', ['cartContents']),
		hasDiscount() {
			return (
				this.product &&
				this.product.old_price &&
				this.product.old_price !== '0.00'
			);
		},
	},
	created() {
		this.fetchProductData();
	},
	mounted() {
		this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
	},
	watch: {
		id() {
			this.fetchProductData();
		},
		currencyCode() {
			this.fetchProductData();
		},
		// chartData(newData) {
		//     if (newData.length > 0) {
		//         this.createChart();
		//     }
		// },
	},
	methods: {
		goBack() {
			this.$router.go(-1);
		},
		generateBreadcrumbs() {
			if (!this.product) return [];

			return [
				// {
				//     text: this.product.category,
				//     link: `/products/${this.product.category}`,
				// },
				{
					text: this.product.type,
					link: `/products/${this.product.type}`,
				},
				{
					text: this.product.title,
					link: `/product/${this.product.id}`,
				},
			];
		},
		addToCart(item) {
			if (this.isAuth) {
				const itemAlreadyInCart = this.cartContents.some(
					(cartItem) => cartItem.item_id === item.id
				);

				if (itemAlreadyInCart) {
					this.$toast.info(this.$t('This item is already in your cart.'));
					return;
				}
				this.$emit('addToCart', item);
			} else {
				this.$router.push('/signin');
			}
		},
		addToCartAndBuy(item) {
			if (this.isAuth) {
				const itemAlreadyInCart = this.cartContents.some(
					(cartItem) => cartItem.item_id === item.id
				);

				if (itemAlreadyInCart) {
					this.$toast.info(this.$t('This item is already in your cart.'));
					this.$router.push('/cart');
					return;
				}
				this.$emit('addToCart', item);
				this.$router.push('/cart');
			} else {
				this.$router.push('/signin');
			}
		},
		fetchProductData() {
			this.productLoading = true;
			const apiEndpoint = `items/${this.id}`;
			this.$http
				.get(`${apiEndpoint}`, {
					params: {
						currency: this.currencyCode,
						include_price_history: true,
					},
				})
				.then((res) => {
					this.product = res.data.payload;
				})
				.catch((error) => {
					console.error('Failed to load product data:', error);
				})
				.finally(() => {
					this.productLoading = false;
				});
		},
		// createChart() {
		//     this.$nextTick(() => {
		//         const canvas = this.$refs.chartCanvas;
		//         if (canvas && this.chartData.length > 0) {
		//             this.destroyChart();
		//             const ctx = canvas.getContext('2d');

		//             this.chart = new Chart(ctx, {
		//                 type: 'line',
		//                 data: {
		//                     labels: this.chartData.map(data => data.date),
		//                     datasets: [{
		//                         label: 'Price',
		//                         data: this.chartData.map(data => data.price),
		//                         borderColor: '#15CA5C',
		//                         borderWidth: 2,
		//                         pointBackgroundColor: '#15CA5C',
		//                         pointBorderColor: '#15CA5C',
		//                         pointRadius: 0,
		//                         pointHoverRadius: 5,
		//                         tension: 0
		//                     }]
		//                 },
		//                 options: {
		//                     responsive: true,
		//                     maintainAspectRatio: false,
		//                     layout: {
		//                         padding: {
		//                             top: 16,
		//                             right: 42,
		//                             bottom: 16,
		//                             left: 16
		//                         }
		//                     },
		//                     scales: {
		//                         x: {
		//                             grid: {
		//                                 color: (context) => {
		//                                     if (context.index === 0 || context.index == this.chartData.length - 1) {
		//                                         return 'transparent';
		//                                     }
		//                                     return '#3B4858';
		//                                 },
		//                                 lineWidth: 1,
		//                                 drawBorder: false
		//                             },
		//                             border: { display: false },
		//                             ticks: {
		//                                 autoSkip: true,
		//                                 maxTicksLimit: 8,
		//                                 font: {
		//                                     family: 'Oxanium',
		//                                     size: 14,
		//                                     weight: 500
		//                                 },
		//                                 color: 'white',
		//                                 callback: (index) => {
		//                                     return this.chartData[index].date.slice(0, -4);
		//                                 }
		//                             },
		//                         },
		//                         y: {
		//                             grid: {
		//                                 color: '#3B4858',
		//                                 lineWidth: 1,
		//                                 drawBorder: false,
		//                             },
		//                             border: { display: false },
		//                             ticks: {
		//                                 font: {
		//                                     family: 'Oxanium',
		//                                     size: 14,
		//                                     weight: 500
		//                                 },
		//                                 autoSkip: false,
		//                                 count: 7,
		//                                 color: 'white',
		//                                 callback: (value, index, values) => (index == (values.length - 1) || index == 0) ? undefined : ` ${value.toFixed(2)} €`,
		//                             },
		//                             afterDataLimits: (axis) => {
		//                                 const range = axis.max - axis.min;
		//                                 const pixelValue = 31;
		//                                 const chartHeight = axis.chart.height;
		//                                 const valuePerPixel = range / chartHeight;
		//                                 const valueIncrease = pixelValue * valuePerPixel;

		//                                 axis.max += valueIncrease;
		//                                 axis.min -= valueIncrease;
		//                             }
		//                         }
		//                     },
		//                     plugins: {
		//                         legend: {
		//                             display: false
		//                         },
		//                         tooltip: {
		//                             backgroundColor: '#070B1C',
		//                             titleFont: {
		//                                 family: 'Oxanium',
		//                                 size: 14,
		//                                 weight: 500
		//                             },
		//                             bodyFont: {
		//                                 family: 'Oxanium',
		//                                 size: 14,
		//                                 weight: 500
		//                             },
		//                             padding: 10,
		//                             cornerRadius: 8,
		//                             displayColors: false,
		//                             boxPadding: 0,
		//                             callbacks: {
		//                                 title: (tooltipItems) => {
		//                                     const item = tooltipItems[0];
		//                                     return `${item.label}`;
		//                                 },
		//                                 label: (context) => {
		//                                     return `CDN ${context.parsed.y.toFixed(2)} €`;
		//                                 },
		//                                 afterLabel: (context) => {
		//                                     const dataPoint = this.chartData[context.dataIndex];
		//                                     return `${dataPoint.count} sold`;
		//                                 }
		//                             }
		//                         },
		//                     },
		//                     elements: {
		//                         point: {
		//                             radius: 1,
		//                             hoverRadius: 8,
		//                             hitRadius: 20
		//                         }
		//                     }
		//                 }
		//             });
		//         }
		//     });
		// },
		// destroyChart() {
		//     if (this.chart) {
		//         this.chart.destroy();
		//         this.chart = null;
		//     }
		// },
		goToProduct(item) {
			this.$emit('goToProduct', item);
		},
	},
};
</script>

<style scoped lang="scss">
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;
.product-details {
	@include adaptiveValue('padding-top', 50, 25);
	@include adaptiveValue('padding-bottom', 50, 20);
	&__inner {
	}
	&__top {
		display: flex;
		flex-wrap: wrap;
		gap: 20px;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 37, 10);
		}
	}
	&__back {
		width: 40px;
		height: 40px;
		background-color: var(--hint-color);
		border-radius: 50%;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: background-color 0.3s ease 0s;
		svg {
			path {
				stroke-width: 2px;
				stroke: var(--primary-color);
			}
		}
		@media (any-hover: hover) {
			&:hover {
				background-color: var(--hint-hover-color);
			}
		}
		@media (max-width: $md5) {
			&:not(:last-child) {
				margin-bottom: 15px;
			}
		}
	}
	&__title {
		margin: 0 auto;
	}
	&__body {
		@include adaptiveValue('margin-left', 106, 0, 1470, 992, 1);

		@include adaptiveValue('gap', 115, 25, 1470, 992, 1);
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 128, 35);
		}
		@media (min-width: $md3) {
			display: flex;
		}
	}
	&__image-container {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		flex: 0 1 53.5%;
		background-color: var(--bg-fourth-color);
		border-radius: var(--border-radius-primary);
		height: fit-content;
		@include adaptiveValue('padding-top', 35, 0, 1470, 768, 1);
		@include adaptiveValue('padding-bottom', 35, 0, 1470, 768, 1);
		overflow: hidden;
		@media (max-width: $md2) {
			flex: 0 1 50%;
		}
		@media (max-width: $md3) {
			&:not(:last-child) {
				margin-bottom: 20px;
			}
		}
	}
	&__image-bg {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
	}
	&__image {
		max-width: 450px;
		width: 100%;
		padding-bottom: 51.5%;
		@media (max-width: $md3) {
			padding-bottom: 58.5%;
		}
		@media (max-width: $md4) {
			padding-bottom: 65.5%;
		}
		@media (max-width: $md4) {
			padding-bottom: 71%;
		}
	}
	&__added-inscriptio {
	}
	&__info {
		flex: 0 1 46.5%;
		@include adaptiveValue('padding-top', 30, 0, 1470, 992, 1);
		@media (max-width: $md2) {
			flex: 0 1 50%;
		}
	}
	&__name {
		text-transform: uppercase;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 40, 20);
		}
	}
	&__about {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 25, 20);
		}
		&-item {
			display: flex;
			align-items: center;
			gap: 8px;
			&:not(:last-child) {
				@include adaptiveValue('margin-bottom', 15, 10);
			}
		}
		&-name {
			opacity: 0.5;
			color: var(--secondary-color);
			font-weight: 400;
		}
		&-value {
			color: var(--primary-color);
			font-weight: 400;
		}
	}
	&__bottom {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		gap: 20px;
	}
	&__price {
		display: flex;
		gap: 10px;
		height: fit-content;
		&-label {
			color: var(--secondary-color);
			font-weight: 400;
			opacity: 0.5;
			align-self: flex-end;
			transform: translate(0px, -30%);
			height: fit-content;
		}
		&-value {
			font-family: var(--font-family-geologica);
			font-weight: 900;
			@include adaptiveValue('font-size', 48, 28);
			@include adaptiveValue('line-height', 56, 36);
		}
		&-icon {
			align-self: center;
			@include adaptiveValue('min-width', 48, 28);
			@include adaptiveValue('height', 48, 28);
		}
	}
	&__actions {
		display: flex;
		flex-wrap: wrap;
		gap: 16px;
		@media (max-width: $md4) {
			gap: 6px;
		}
	}
	&__button {
		min-width: 200px;
		@media (max-width: $md4) {
			max-width: 300px;
			width: 100%;
			margin: 0 auto;
		}
	}
	&__no-product {
		min-height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
}
</style>
